import React, { useState, useEffect } from "react";
import Game from "./Game";
import SuperBowlChamp from "./SuperbowlChamp";
import "./styles.css";
import { nfcTeams, afcTeams, sbtrophy } from "./teamData";

export default function App() {
  const [round2NFCteams, setRound2NFCteams] = useState([nfcTeams[0]]);
  const [round2AFCteams, setRound2AFCteams] = useState([afcTeams[0]]);
  const [round1NFCwinners, setRound1NFCwinners] = useState([null, null, null]);
  const [round2NFCwinners, setRound2NFCwinners] = useState([]);
  const [round1AFCwinners, setRound1AFCwinners] = useState([null, null, null]);
  const [round2AFCwinners, setRound2AFCwinners] = useState([]);
  const [round2AFCgames, setRound2AFCgames] = useState([[], []]);
  const [round2NFCgames, setRound2NFCgames] = useState([[], []]);
  const [round3AFCgame, setRound3AFCgame] = useState([[], []]);
  const [round3NFCgame, setRound3NFCgame] = useState([[], []]);
  const [superBowlNFC, setSuperBowlNFC] = useState([]);
  const [superBowlAFC, setSuperBowlAFC] = useState([]);
  const [superBowlWinner, setSuperBowlWinner] = useState([]);

  const handleClick = (team, round, game, setPicked, t1, t2) => {
    console.log(team);
    if (team) {
      if (t2) {
        setPicked(t2);
      }
      if (t1) {
        setPicked(t1);
      }

      if (round === "nfc1") {
        setRound2NFCwinners([]);
        setSuperBowlNFC([]);
        setSuperBowlWinner([]);
        setRound1NFCwinners((prev) => {
          const temp = [...prev];
          temp[game - 1] = team;
          return temp;
        });
      }
      if (round === "afc1") {
        setRound2AFCwinners([]);
        setSuperBowlAFC([]);
        setSuperBowlWinner([]);
        setRound1AFCwinners((prev) => {
          const temp = [...prev];
          temp[game - 1] = team;
          return temp;
        });
      }
      if (round === "nfc2") {
        setSuperBowlNFC([]);
        setSuperBowlWinner([]);
        setRound2NFCwinners((prev) => {
          const temp = [...prev];
          temp[game - 1] = team;
          return temp;
        });
      }
      if (round === "afc2") {
        setSuperBowlAFC([]);
        setSuperBowlWinner([]);
        setRound2AFCwinners((prev) => {
          const temp = [...prev];
          temp[game - 1] = team;
          return temp;
        });
      }
      if (round === "nfc3") {
        setSuperBowlNFC(team);
      }
      if (round === "afc3") {
        setSuperBowlAFC(team);
      }
      if (round === "superbowl") {
        setSuperBowlWinner(team);
      }
    }
  };

  useEffect(() => {
    if (round1AFCwinners.every((e) => e !== null)) {
      const rnd1AFC = [...round1AFCwinners];
      rnd1AFC.sort((a, b) => a.seed - b.seed);
      setRound2AFCgames([
        [afcTeams[0], rnd1AFC[2]],
        [rnd1AFC[1], rnd1AFC[0]]
      ]);
    }
    if (round1NFCwinners.every((e) => e !== null)) {
      const rnd1NFC = [...round1NFCwinners];
      rnd1NFC.sort((a, b) => a.seed - b.seed);
      setRound2NFCgames([
        [nfcTeams[0], rnd1NFC[2]],
        [rnd1NFC[1], rnd1NFC[0]]
      ]);
    }
  }, [round1NFCwinners, round1AFCwinners]);

  useEffect(() => {
    if (round2NFCwinners[0] || round2NFCwinners[1]) {
      setRound3NFCgame(round2NFCwinners);
    } else {
      setRound3NFCgame([]);
    }
  }, [round2NFCwinners]);

  useEffect(() => {
    if (round2AFCwinners[0] || round2AFCwinners[1]) {
      setRound3AFCgame(round2AFCwinners);
    } else {
      setRound3AFCgame([]);
    }
  }, [round2AFCwinners]);

  return (
    <div className="container">
      <div className="nfc">
        <div className="round-one">
          <Game
            game="1"
            round="nfc1"
            teams={[nfcTeams[6], nfcTeams[1]]}
            handleClick={handleClick}
          />
          <Game
            game="2"
            round="nfc1"
            teams={[nfcTeams[5], nfcTeams[2]]}
            handleClick={handleClick}
          />
          <Game
            game="3"
            round="nfc1"
            teams={[nfcTeams[4], nfcTeams[3]]}
            handleClick={handleClick}
          />
        </div>
        <div className="round-two">
          <Game
            game="1"
            round="nfc2"
            teams={round2NFCgames[0]}
            handleClick={handleClick}
          />
          <Game
            game="2"
            round="nfc2"
            teams={round2NFCgames[1]}
            handleClick={handleClick}
          />
        </div>
        <div className="conf-champs game">
          NFC
          <Game round="nfc3" teams={round3NFCgame} handleClick={handleClick} />
        </div>
      </div>
      <SuperBowlChamp team={superBowlWinner} trophy={sbtrophy} />
      <div className="superbowl">
        SUPERBOWL
        <div className="superbowl-matchup">
          <Game
            round="superbowl"
            teams={[superBowlNFC, superBowlAFC]}
            handleClick={handleClick}
          />
        </div>
      </div>
      <div className="afc">
        <div className="round-one">
          <Game
            game="1"
            round="afc1"
            teams={[afcTeams[6], afcTeams[1]]}
            handleClick={handleClick}
          />
          <Game
            game="2"
            round="afc1"
            teams={[afcTeams[5], afcTeams[2]]}
            handleClick={handleClick}
          />
          <Game
            game="3"
            round="afc1"
            teams={[afcTeams[4], afcTeams[3]]}
            handleClick={handleClick}
          />
        </div>
        <div className="round-two">
          <Game
            game="1"
            round="afc2"
            teams={round2AFCgames[0]}
            handleClick={handleClick}
          />
          <Game
            game="2"
            round="afc2"
            teams={round2AFCgames[1]}
            handleClick={handleClick}
          />
        </div>
        <div className="conf-champs game">
          AFC
          <Game round="afc3" teams={round3AFCgame} handleClick={handleClick} />
        </div>
        <input type="text" className="name-input" placeholder="enter name" />
      </div>
    </div>
  );
}
